export default function Marquee({ items = [] }) {
  if (!items.length) return null;
  return (
    <div className="border-y border-black/10 bg-white py-5 overflow-hidden" data-testid="marquee-band">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center shrink-0">
            {items.map((it, i) => (
              <span key={i} className="flex items-center font-display font-bold uppercase text-xl md:text-2xl text-zinc-700 tracking-tight">
                <span className="px-7">{it}</span>
                <span className="inline-block h-2 w-2 rotate-45 bg-citek-green" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
